import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../../api/api';

export const loadAdminDashboard = createAsyncThunk(
  'adminDashboard/load',
  async (filters = {}) => {
    return await api.admin.dashboard(filters);
  },
);

export const loadUpgradeInfo = createAsyncThunk(
  'adminDashboard/loadUpgradeInfo',
  async () => {
    return await api.admin.upgrade.available();
  },
);

export const loadAdminResourceUsage = createAsyncThunk(
  'adminDashboard/resourceUsage',
  async () => {
    return await api.admin.resourceUsage();
  },
);

const adminDashboardSlice = createSlice({
  name: 'adminDashboard',
  initialState: {
    data: null,
    loading: false,
    error: null,
    filters: {
      period_days: 7,
      from_date: null,
      to_date: null,
    },
    upgradeInfo: null,
    upgradeInfoLoading: false,
    resourceUsage: null,
    resourceUsageLoading: false,
  },
  reducers: {
    setAdminDashboardFilters(state, action) {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: {
    [loadAdminDashboard.pending]: (state) => {
      state.loading = true;
      state.error = null;
    },
    [loadAdminDashboard.fulfilled]: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    [loadAdminDashboard.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    },
    [loadUpgradeInfo.pending]: (state) => {
      state.upgradeInfoLoading = true;
    },
    [loadUpgradeInfo.fulfilled]: (state, action) => {
      state.upgradeInfoLoading = false;
      state.upgradeInfo = action.payload;
    },
    [loadUpgradeInfo.rejected]: (state) => {
      state.upgradeInfoLoading = false;
    },
    [loadAdminResourceUsage.pending]: (state) => {
      state.resourceUsageLoading = true;
    },
    [loadAdminResourceUsage.fulfilled]: (state, action) => {
      state.resourceUsageLoading = false;
      state.resourceUsage = action.payload;
    },
    [loadAdminResourceUsage.rejected]: (state) => {
      state.resourceUsageLoading = false;
    },
  },
});

export const { setAdminDashboardFilters } = adminDashboardSlice.actions;

export const selectAdminDashboard = (state) => state.adminDashboard.data;
export const selectAdminDashboardLoading = (state) =>
  state.adminDashboard.loading;
export const selectAdminDashboardError = (state) => state.adminDashboard.error;
export const selectAdminDashboardFilters = (state) =>
  state.adminDashboard.filters;
export const selectUpgradeInfo = (state) => state.adminDashboard.upgradeInfo;
export const selectUpgradeInfoLoading = (state) =>
  state.adminDashboard.upgradeInfoLoading;
export const selectAdminResourceUsage = (state) =>
  state.adminDashboard.resourceUsage;
export const selectAdminResourceUsageLoading = (state) =>
  state.adminDashboard.resourceUsageLoading;

export default adminDashboardSlice.reducer;
